import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsInterventionsOperationsProgressReportComponent } from './fields-interventions-operations-progress-report.component';
import {DxChartModule, DxPivotGridModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsInterventionsOperationsProgressReportComponent],
  imports: [
    CommonModule,
    DxPivotGridModule,
    DxChartModule
  ],
  exports: [FieldsInterventionsOperationsProgressReportComponent]
})
export class FieldsInterventionsOperationsProgressReportModule { }
